import { render, staticRenderFns } from "./Flap.vue?vue&type=template&id=66dc3bac&scoped=true&"
import script from "./Flap.vue?vue&type=script&lang=js&"
export * from "./Flap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc3bac",
  null
  
)

export default component.exports